import { useSWRMutation } from '@tiger/swr';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast from 'components/Toast';
import { PlaidBankCardItem } from 'components/vendor/plaid/PlaidLink/types';
import { UpdatePlaidLocationState } from 'components/vendor/type';
import arrowIcon from 'static/images/icons/icon-arrow.svg';
import security from 'stores/security';
import { Source } from 'types/funding';
import API from 'utils/API';
import http from 'utils/http';
import AchBankItem from '../../AchBankItem';

interface AchUnableBankCardListProps {
    data: PlaidBankCardItem[];
    source: Source;
}

const AchUnableBankCardList: React.FC<AchUnableBankCardListProps> = ({ data, source }) => {
    const navigate = useNavigate();
    const { trigger } = useSWRMutation('refresh.ach.plaid.bankcard', (id: string) =>
        http
            .get<{
                public_token: string;
            }>(API.TRADE.funding.refreshCard(), {
                params: {
                    plaid_account_id: id,
                    customer_id: security.currentCustomerId,
                    account_id: security.currentAccountId
                }
            })
            .then(({ data }) => data)
    );
    const list = useMemo(() => {
        return data.filter(({ status, id_source }) => {
            /**
             * plaid银行卡不展示
             * 手动认证银行卡入金展示不可用的、出金展示不可用和审核中
             */
            if (id_source === 'Bank') {
                if (source === 'deposit') {
                    return ['ERROR'].includes(status);
                }

                return ['ERROR', 'VERIFIED'].includes(status);
            }

            return false;
        });
    }, [data, source]);

    const handleAchBank = async (item: PlaidBankCardItem) => {
        const { id_source, account_id } = item;

        if (id_source === 'Fund') {
            Toast.loading(true);

            try {
                const data = await trigger(account_id);

                Toast.loading(false);

                const updatePlaidState: UpdatePlaidLocationState = {
                    selectedBank: item,
                    token: data?.public_token,
                    source: source
                };

                navigate(`/profile/${source}/ach/update-plaid`, {
                    state: updatePlaidState,
                    replace: true
                });
            } catch (error) {
                Toast.loading(false);
                Toast.show(error);
            }
        } else {
            navigate('/profile/bankcards/auth/select-way', {
                state: {
                    id: item.id,
                    source
                }
            });
        }
    };

    if (!list.length) {
        return null;
    }

    return (
        <div className="ach-unable-bankcard-list">
            <h4>{__('The following accounts are pending verification:')}</h4>
            <div>
                {list.map(item => {
                    const { id } = item;

                    return (
                        <div
                            key={id}
                            className="ach-bank-item"
                            onClick={() => {
                                handleAchBank(item);
                            }}>
                            <AchBankItem info={item} showStatusTag />
                            <img src={arrowIcon} className="arrow" alt="" />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AchUnableBankCardList;
